'use strict';
const orgKey=v=>String(v??'').replace(/\s/g,'');
function validOrg(value){
 const s=orgKey(value);if(!/^\d{9}$/.test(s))return false;
 const check=11-[3,2,7,6,5,4,3,2].reduce((sum,w,i)=>sum+w*Number(s[i]),0)%11;
 return check!==10 && (check===11?0:check)===Number(s[8]);
}
function verifiedBinding(identity,org,directoryId){
 return identity?.status==='verified' && validOrg(org) && identity.orgNr===orgKey(org)
  && typeof identity.sourceIdentity==='string' && !!identity.sourceIdentity.trim()
  && typeof identity.directoryId==='string' && !!identity.directoryId && identity.directoryId===String(directoryId);
}
function matchCatalogAssignment({orgNr,sourceIdentity,catalog,directory,source='24so'}){
 const unknown={status:'unknown',reason:'identity_unverified'};
 const org=orgKey(orgNr),wanted=String(sourceIdentity||'').replace(/^tripletex:/,'');
 const rowOrg=r=>orgKey(r.organizationNumber||r.orgNumber||r.orgNr);
 const id=r=>String(source==='tripletex'?r.companyId??r.identityId??'':r.identityId??'').replace(/^tripletex:/,'');
 if(!validOrg(org)||!wanted||!Array.isArray(catalog)||!Array.isArray(directory))return unknown;
 const peers=catalog.filter(r=>rowOrg(r)===org),ids=catalog.filter(r=>id(r)===wanted),links=directory.filter(r=>rowOrg(r)===org);
 if(peers.length!==1||ids.length!==1||peers[0]!==ids[0]||peers[0].isDisabled||links.length!==1||/inaktiv|inactive/i.test(String(links[0].active||'')))return unknown;
 return {status:'verified',orgNr:org,sourceIdentity:wanted,accountant:links[0].accountant||'',assignment:links[0]};
}
// Independent catalog data, never a trust flag supplied by an API caller.
function matchIdentity({orgNr,sourceIdentity,directoryId,catalog,directory,source='24so'}){
 const unknown={status:'unknown',reason:'identity_unverified'};
 const org=orgKey(orgNr);
 const rowOrg=r=>orgKey(r.organizationNumber||r.orgNumber||r.orgNr);
 const id=r=>String(source==='tripletex' ? r.companyId??r.identityId??'' : r.identityId??'').replace(/^tripletex:/,'');
 const wanted=String(sourceIdentity||'').replace(/^tripletex:/,'');
 if(!validOrg(org)||!wanted||!Array.isArray(catalog)||!Array.isArray(directory))return unknown;
 const peers=catalog.filter(r=>rowOrg(r)===org), identities=catalog.filter(r=>id(r)===wanted);
 const links=directory.filter(r=>rowOrg(r)===org), dirs=directory.filter(r=>String(r.id??r.ID??r.directoryId??'')===String(directoryId));
 if(peers.length!==1||identities.length!==1||peers[0]!==identities[0]||peers[0].isDisabled
  ||links.length!==1||dirs.length!==1||links[0]!==dirs[0]||/inaktiv|inactive/i.test(String(links[0].active||'')))return unknown;
 return {status:'verified',orgNr:org,sourceIdentity:wanted,directoryId:String(directoryId),source};
}
module.exports={validOrg,verifiedBinding,matchIdentity,matchCatalogAssignment};
